import * as amplitude from '@amplitude/analytics-browser'
import { toast } from 'sonner'
import { Icon } from '#app/components/ui/icon'
import { logAddToCartEvent } from '#app/utils/tracking/clerk-tracking'
import { addToCartEventMeta } from '../meta/add-to-cart'

const calculatePhantomShare = (
	options: {
		label: string
		value: string
		disabled: boolean
		badgeProps: { type: string; text: string } | undefined
	}[],
) => {
	const totalOptions = options.length
	const disabledOptions = options.filter(
		(option: { disabled: any }) => option.disabled,
	).length
	const phantomSharePercentage = (disabledOptions / totalOptions) * 100
	return phantomSharePercentage.toFixed(2) // Keep only two decimal places for cleanliness.
}

export const trackProductAdded = (
	selectedSku: string,
	productData: any,
	activeStyle: any,
	firstAvailability: any[],
	amplitudePageSource: any,
	sizeOptions: any,
	clerkVisitor: any,
	metaPixelFetcher: any,
	t: any,
) => {
	const selectedVariant = activeStyle.variants.find(
		(variant: any) => variant.sku === selectedSku,
	)

	if (selectedVariant) {
		const originalPrice =
			selectedVariant.prices && selectedVariant.prices.length > 0
				? selectedVariant.prices[0].value.centAmount / 100
				: 0 // Convert centAmount to standard currency format

		const discountedPrice = selectedVariant.lowestPrice?.discounted
			? selectedVariant.lowestPrice.discounted.value.centAmount / 100
			: originalPrice // Use discounted price if available, otherwise fallback to original price

		const discountPercentage =
			originalPrice > 0
				? ((originalPrice - discountedPrice) / originalPrice) * 100
				: 0 // Calculate discount percentage

		const phantomShare = calculatePhantomShare(sizeOptions)
		const isDiscounted = discountedPrice < originalPrice

		const eventData = {
			sku: selectedSku,
			styleNumber: productData?.productInfo.key || '',
			name: productData?.productInfo.name.en || '',
			Store_name: firstAvailability[0]?.storeName ?? '',
			gender:
				selectedVariant.attributes?.find((attr: any) => attr.name === 'gender')
					?.value.en ?? '',
			age_group:
				selectedVariant.attributes?.find(
					(attr: any) => attr.name === 'age_group',
				)?.value ?? '',
			brand:
				selectedVariant.attributes?.find(
					(attr: { name: string }) => attr.name === 'brand',
				)?.value || '',
			color:
				selectedVariant.attributes?.find(
					(attr: { name: string }) => attr.name === 'color',
				)?.value.en || '',
			target_group:
				selectedVariant.attributes?.find(
					(attr: any) => attr.name === 'target_group',
				)?.value.en ?? '',
			price: discountedPrice, // Use discounted price for the event
			discountPercentage: discountPercentage.toFixed(2), // Keep only two decimal places
			isDiscounted: isDiscounted,

			phantomShare: phantomShare, // Adding phantom share to event data
			page_source: amplitudePageSource, // Use the amplitudePageSource from the state or default to 'Direct'
		}
		const id = `${productData.productInfo.key}-${selectedVariant.styleVariantKey}`

		amplitude.track('Product added', eventData) // amplitude
		addToCartEventMeta(selectedSku, eventData) // meta
		logAddToCartEvent(id, 1, discountedPrice, clerkVisitor) // clerk
	} else {
		toast(t('size_not_selected_error'), {
			icon: <Icon name="exclamation" size="lg" />,
		})
	}
}
